// A <select> is as wide as its longest option, so a short choice ("Lane lines") sits
// in a box sized for the longest one. Sized to the selected text instead; the open
// list stays the browser's own. (CSS field-sizing: content would do this, but Safari
// does not support it.)

const SIDES = [
  "paddingLeft",
  "paddingRight",
  "borderLeftWidth",
  "borderRightWidth",
];
// Covers sub-pixel rounding and a web font that loads after the measurement.
const SLACK_PX = 2;

/**
 * @param {number} textWidth measured width of the selected option's text
 * @param {Partial<CSSStyleDeclaration>} style the select's computed style
 */
export function selectWidthPx(textWidth, style) {
  const sides = SIDES.reduce(
    (sum, key) => sum + (parseFloat(style[key]) || 0),
    0,
  );
  return Math.ceil(textWidth + sides) + SLACK_PX;
}
